import { Navigate } from 'react-router-dom';

import { AuthRedirectPage } from 'pages/AuthRedirectPage';
import BrandManagementPage from 'pages/BrandManagementPage';
import { CatalogMatchJobDetailsPage } from 'pages/CatalogMatchJobDetails';
import { CatalogMatchJobsPage } from 'pages/CatalogMatchJobsPage';
import { CatalogSearchPage } from 'pages/CatalogSearchPage';
import { CatalogUploadPage } from 'pages/CatalogUploadPage';
import { ExternalMatchesPage } from 'pages/ExternalMatchesPage';
import FergusonAdhocImportPage from 'pages/FergusonAdhocImportPage';
import { GeneralSearchPage } from 'pages/GeneralSearchPage';
import { LoginRedirectPage } from 'pages/LoginRedirectPage';
import { MainPage } from 'pages/MainPage';
import ManufacturerManagementPage from 'pages/ManufacturerManagementPage';
import { NotFoundPage } from 'pages/NotFoundPage';
import { SimilarProductsJobDetailsPage } from 'pages/SimilarProductsJobDetailsPage';
import { SimilarProductsJobsPage } from 'pages/SimilarProductsJobsPage';
import SupplierCatalogFilesPage from 'pages/SupplierCatalogFilesPage';
import SupplierCatalogJobDebugPage from 'pages/SupplierCatalogJobDebug';
import SupplierCatalogJobDetailsPage from 'pages/SupplierCatalogJobDetails';
import SupplierCatalogUploadPage from 'pages/SupplierCatalogUploadPage';
import SupplierCategoryMappingsPage from 'pages/SupplierCategoryMappingsPage';
import SupplierManagementPage from 'pages/SupplierManagementPage';
import UomManagementPage from 'pages/UomManagementPage';
import {
  AppRoutes,
  getRouteAuth,
  getRouteBrandManagement,
  getRouteCatalogMatchJobDetails,
  getRouteCatalogMatchJobs,
  getRouteCatalogSearch,
  getRouteCatalogUpload,
  getRouteExternalMatches,
  getRouteGeneralSearch,
  getRouteLogin,
  getRouteMain,
  getRouteManufacturerManagement,
  getRouteNotFound,
  getRouteSimilarProducts,
  getRouteSimilarProductsJobDetails,
  getRouteSupplierCatalogFergusonAdhoc,
  getRouteSupplierCatalogFiles,
  getRouteSupplierCatalogJobDebug,
  getRouteSupplierCatalogJobDetails,
  getRouteSupplierCatalogUpload,
  getRouteSupplierCategoryMappings,
  getRouteSupplierManagement,
  getRouteUomManagement,
  getRouteUomManagementLegacy,
} from 'shared/constants/routerConst';
import { AppRoutesProps } from 'shared/types/router';

export const routeConfig: Partial<Record<AppRoutes, AppRoutesProps>> = {
  [AppRoutes.MAIN]: {
    path: getRouteMain(),
    element: <MainPage />,
  },
  [AppRoutes.LOGIN]: {
    path: getRouteLogin(),
    element: <LoginRedirectPage />,
  },
  [AppRoutes.AUTH]: {
    path: getRouteAuth(),
    element: <AuthRedirectPage />,
  },
  [AppRoutes.GENERAL_SEARCH]: {
    authOnly: true,
    path: getRouteGeneralSearch(),
    element: <GeneralSearchPage />,
  },
  [AppRoutes.CATALOG_SEARCH]: {
    authOnly: true,
    path: getRouteCatalogSearch(),
    element: <CatalogSearchPage />,
  },
  [AppRoutes.CATALOG_UPLOAD]: {
    authOnly: true,
    path: getRouteCatalogUpload(),
    element: <CatalogUploadPage />,
  },
  [AppRoutes.SUPPLIER_CATALOG_FILES]: {
    authOnly: true,
    path: getRouteSupplierCatalogFiles(),
    element: <SupplierCatalogFilesPage />,
  },
  [AppRoutes.SUPPLIER_CATALOG_JOB_DETAILS]: {
    authOnly: true,
    path: getRouteSupplierCatalogJobDetails(':jobId'),
    element: <SupplierCatalogJobDetailsPage />,
  },
  [AppRoutes.SUPPLIER_CATALOG_JOB_DEBUG]: {
    authOnly: true,
    path: getRouteSupplierCatalogJobDebug(':jobId'),
    element: <SupplierCatalogJobDebugPage />,
  },
  [AppRoutes.SUPPLIER_CATALOG_UPLOAD]: {
    authOnly: true,
    path: getRouteSupplierCatalogUpload(),
    element: <SupplierCatalogUploadPage />,
  },
  [AppRoutes.SUPPLIER_CATALOG_FERGUSON_ADHOC]: {
    authOnly: true,
    path: getRouteSupplierCatalogFergusonAdhoc(),
    element: <FergusonAdhocImportPage />,
  },
  [AppRoutes.CATALOG_MATCH_JOBS]: {
    authOnly: true,
    path: getRouteCatalogMatchJobs(),
    element: <CatalogMatchJobsPage />,
  },
  [AppRoutes.CATALOG_MATCH_JOB_DETAILS]: {
    authOnly: true,
    path: getRouteCatalogMatchJobDetails(':jobId'),
    element: <CatalogMatchJobDetailsPage />,
  },
  [AppRoutes.SIMILAR_PRODUCTS]: {
    authOnly: true,
    path: getRouteSimilarProducts(),
    element: <SimilarProductsJobsPage />,
  },
  [AppRoutes.SIMILAR_PRODUCTS_JOB_DETAILS]: {
    authOnly: true,
    path: getRouteSimilarProductsJobDetails(':jobId'),
    element: <SimilarProductsJobDetailsPage />,
  },
  [AppRoutes.SUPPLIER_MANAGEMENT]: {
    authOnly: true,
    path: getRouteSupplierManagement(),
    element: <SupplierManagementPage />,
  },
  [AppRoutes.SUPPLIER_CATEGORY_MAPPINGS]: {
    authOnly: true,
    path: getRouteSupplierCategoryMappings(':supplierId'),
    element: <SupplierCategoryMappingsPage />,
  },
  [AppRoutes.BRAND_MANAGEMENT]: {
    authOnly: true,
    path: getRouteBrandManagement(),
    element: <BrandManagementPage />,
  },
  [AppRoutes.MANUFACTURER_MANAGEMENT]: {
    authOnly: true,
    path: getRouteManufacturerManagement(),
    element: <ManufacturerManagementPage />,
  },
  [AppRoutes.UOM_MANAGEMENT]: {
    authOnly: true,
    path: getRouteUomManagement(),
    element: <UomManagementPage />,
  },
  [AppRoutes.UOM_MANAGEMENT_LEGACY]: {
    authOnly: true,
    path: getRouteUomManagementLegacy(),
    element: <Navigate to={getRouteUomManagement()} replace />,
  },
  [AppRoutes.EXTERNAL_MATCHES]: {
    authOnly: true,
    path: getRouteExternalMatches(),
    element: <ExternalMatchesPage />,
  },
  // error pages
  [AppRoutes.NOT_FOUND_PAGE]: {
    path: getRouteNotFound(),
    element: <NotFoundPage />,
  },
  // last
  [AppRoutes.NOT_FOUND]: {
    path: '*',
    element: <NotFoundPage />,
  },
};
